import { render, staticRenderFns } from "./PersonAsset.vue?vue&type=template&id=0532443a&scoped=true&"
import script from "./PersonAsset.vue?vue&type=script&lang=js&"
export * from "./PersonAsset.vue?vue&type=script&lang=js&"
import style0 from "./PersonAsset.vue?vue&type=style&index=0&id=0532443a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0532443a",
  null
  
)

export default component.exports